import { HrefLink } from '@smartbear/swagger-portal-component-library'
import { clsx } from 'clsx'
import { useTranslation } from 'react-i18next'

import { UNLIMITED, useApiHubPlan } from '~/portal/hooks/useApiHubPlan'
import { useShubOrgInfo } from '~/shared/hooks/useShubOrgInfo'
import { API_HUB_PLAN } from '~/shared/types/portal'

const GatingInfoBox = () => {
  const { t } = useTranslation()
  const { name, productMeters = { currentUsage: 0, warningThreshold: 0, limit: 0 }, getUpgradeUrl, getUpgradeLabel, platformManaged } = useApiHubPlan() || {}
  const { organizationRole } = useShubOrgInfo()  
  const { currentUsage, warningThreshold, limit } = productMeters

  if (!name || name === API_HUB_PLAN.BEST || !platformManaged || limit === UNLIMITED) {
    return null
  }

  return (
    <div>
      <div className="flex w-full h-[5px] rounded-t">
        <div 
          data-testid="progress-bar-used"
          className={clsx(
            'rounded-tl',
            currentUsage > 0 && currentUsage < warningThreshold && 'bg-success-40',
            currentUsage > 0 && currentUsage >= warningThreshold && 'bg-warning-30', 
          )} 
          style={{ width: `${(currentUsage / limit) * 100}%` }} 
        />
        <div 
          data-testid="progress-bar-unused"
          className={clsx(
            'bg-neutral-20 dark:bg-neutral-80 rounded-tr',
            ((limit - currentUsage) / limit) * 100 === 100 && 'rounded-tl'
          )} 
          style={{ width: `${((limit - currentUsage) / limit) * 100}%` }} 
        />
      </div>
      <div 
        className="bg-[#F5F6F89C] dark:bg-neutral-95 border-neutral-20 dark:border-neutral-80 text-neutral-98  dark:text-neutral-40
        flex flex-col font-semibold px-4 py-2 rounded-bl rounded-br text-body3 border-b border-l border-r"
      >
        {t('entitlements.meters.product.warning', { productsLeft: limit - currentUsage, limit: limit })}
        <HrefLink
          label={getUpgradeLabel(organizationRole)}
          isExternal
          target="_blank"
          size="small"
          href={getUpgradeUrl(organizationRole)}
        />
      </div>
    </div>
  ) 
}

export default GatingInfoBox